import { Component, Input } from '@angular/core';

import { MenuService } from '@core';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
})
export class SidemenuComponent {
  // NOTE: Ripple effect make page flashing on mobile
  @Input() ripple = true;
  menus: string;
  parsedJson: any;

  // menus = this.menuService.getAll();




  constructor(private menuService: MenuService) {
    this.parsedJson = JSON.parse(localStorage.getItem("menulist"));
    this.menus = this.parsedJson.menu;

  }
  removeBenchFilters() {
    sessionStorage.removeItem('filterValuesManageAuditor');
    sessionStorage.removeItem('filterValuesAuditee');
    sessionStorage.removeItem('filterValues');
    sessionStorage.removeItem('filterActiveAuditee');
    sessionStorage.removeItem('filterActive');
    sessionStorage.removeItem('filterActiveManageAuditor');

  }

  // Delete empty value in array
  filterStates(states: string[]) {
    return states.filter(item => item && item.trim());
  }


}
